import React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.css';
import pinIcon from './assets/pin.svg';
import promoPinIcon from './assets/promo-pin.svg';
import { IPinPosition } from 'shared/types/pin';
import { TDeviceType } from '@cian/ui-kit';

interface ISimplePinProps {
  position: IPinPosition;
  showPromoPinsContent: boolean;
  isEntering: boolean;
  isPromoVisible: boolean;
  isPromoExiting: boolean;
  isExiting: boolean;
  device: TDeviceType;
}

export const Pin: React.FC<ISimplePinProps> = ({
  position: { desktop, phone, priceImage, promoPriceImage },
  showPromoPinsContent,
  isEntering,
  isPromoVisible,
  isPromoExiting,
  isExiting,
  device,
}) => {
  const isPhone = device === 'phone';

  const isSimplePin = !showPromoPinsContent;

  return (
    <div
      className={clsx(
        isSimplePin && styles['simple-pin'],
        !isSimplePin && styles['promo-pin'],
        styles[device],
        isSimplePin && isEntering && styles['simple-pin_entering'],
        isSimplePin && isExiting && styles['simple-pin_exiting'],
        !isSimplePin && isPromoVisible && styles['promo-pin_visible'],
        !isSimplePin && isPromoExiting && styles['promo-pin_exiting'],
      )}
      style={{ left: isPhone ? phone.left : desktop.left, top: isPhone ? phone.top : desktop.top }}
    >
      <img
        src={showPromoPinsContent ? promoPriceImage : priceImage}
        alt=""
        className={clsx(styles['simple-pin-price'], showPromoPinsContent && styles['promo-pin-price'])}
      />
      {isPromoVisible && <span className={styles['promo-pin-halo']} aria-hidden />}
      <img
        src={showPromoPinsContent ? promoPinIcon : pinIcon}
        alt=""
        className={clsx(styles['simple-pin-icon'], showPromoPinsContent && styles['promo-pin-icon'])}
      />
    </div>
  );
};
